module.exports = __webpack_public_path__ + "static/media/three-images.bc4aef0f.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/ep5/three-images.jpg
 ** module id = 229
 ** module chunks = 0
 **/